import GenericRequest, { METHOD_POST } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';

export class NotificationSearchTask extends GenericRequest {

    _request; // NotificationSearchRequest

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.NOTIFICATIONS);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/notifications/shared/notification-search/NotificationSearchTask.js